import React from 'react';
import PropTypes from 'prop-types';
import LightBulb from '@learningblocks/exp-constants/lib/Images/lighbulb.svg';
import MoveIcon from '@learningblocks/exp-constants/lib/Images/move.svg';
import TrashCan from '@learningblocks/exp-constants/lib/Images/mini-trash-icon.svg';
import {
  Modal,
  TechniqueCardDescription,
  Image,
} from '@learningblocks/exp-components';
import './style.scss';

export class HexagonNode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
    };
  }

  modalOpen = () => {
    this.setState({modalOpen: true});
  };

  modalClose = () => {
    this.setState({modalOpen: false});
  };

  renderModal = () => {
    return (
      this.state.modalOpen && (
        <Modal
          isOpen={this.state.modalOpen}
          className='md'
          contentLabel={this.props.modal.title}
          closeButton={true}
          close={this.modalClose}>
          <TechniqueCardDescription {...this.props.modal} />
        </Modal>
      )
    );
  };

  renderAddCardIcon = () => {
    const {addCard} = this.props;
    if (addCard !== null) {
      return (
        <>
          <div className='hexagon-top--wrap' />
          <Image src={MoveIcon} alt='move-card-icon' onClick={addCard} />
        </>
      );
    } else return null;
  };

  renderRemoveCardIcon = () => {
    const {removeCard} = this.props;
    if (removeCard !== null) {
      return (
        <>
          <div className='hexagon-top--wrap' />
          <Image src={TrashCan} alt='delete-card-icon' onClick={removeCard} />
        </>
      );
    } else return null;
  };

  render() {
    return (
      <>
        <div className='hexagon'>
          <div className='hexagon-top'>
            {this.renderAddCardIcon()}
            {this.renderRemoveCardIcon()}
          </div>
          <div className='hexagon-middle'>
            <Image src={this.props.image} alt={this.props.title} />
            <span>{this.props.title}</span>
          </div>
          <div className='hexagon-bottom' onClick={this.modalOpen}>
            <Image src={LightBulb} alt='modal-button' />
          </div>
        </div>
        {this.renderModal()}
      </>
    );
  }
}
HexagonNode.propTypes = {
  content: PropTypes.array,
  id: PropTypes.number,
  image: PropTypes.string,
  modal: PropTypes.object,
  title: PropTypes.string,
  type: PropTypes.string,
  addCard: PropTypes.oneOfType([PropTypes.func, PropTypes.any]),
  removeCard: PropTypes.oneOfType([PropTypes.func, PropTypes.any]),
};

HexagonNode.defaultProps = {
  addCard: null,
  removeCard: null,
};
